import { MAX_GAP } from 'hooks/useOverflowCount/constants';
import { getConditionalObject } from 'utils/data';

export const getWrapperStyles = ({ isVertical, gap = MAX_GAP }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  flexWrap: 'nowrap',
  gap: `${gap}px`,

  ...getConditionalObject(isVertical, {
    minWidth: '100%',
    width: 'fit-content',
    flexDirection: 'column',
    alignItems: 'stretch',
    overflow: 'visible',
    gap: '16px',
  }),
});
